{{ status() | adminCosmeticStatus | async }}
